import { styled } from '@mui/material/styles';
import { MenuAction } from 'models/types';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import { drawerWidth } from 'kosmosConfig';
import ProfileNav from 'components/ProfileNav';

const PREFIX = 'SmeAppBar';

const classes = {
  toolbar: `${PREFIX}-toolbar`,
  menuButton: `${PREFIX}-menuButton`,
  menuButtonHidden: `${PREFIX}-menuButtonHidden`,
  title: `${PREFIX}-title`,
};

interface CustomAppBarProps extends AppBarProps {
  open?: boolean;
}

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<CustomAppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [`& .${classes.toolbar}`]: {
    background: 'white',
    color: '#121212',
    paddingRight: 24, // keep right padding when drawer closed
  },
  [`& .${classes.menuButton}`]: {
    marginRight: 36,
  },
  [`& .${classes.title}`]: {
    flexGrow: 1,
  },
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [`& .${classes.menuButton}`]: {
      display: 'none',
    },
  }),
}));

// const StyledAppBar = styled(AppBar)(({ theme }) => ({
//   [`& .${classes.toolbar}`]: {
//     background: 'white',
//     color: '#121212',
//     paddingRight: 24, // keep right padding when drawer closed
//   },
//
//   [`&.${classes.appBar}`]: {
//     zIndex: theme.zIndex.drawer + 1,
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//   },
//
//   [`& .${classes.appBarShift}`]: {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//
//   [`& .${classes.menuButton}`]: {
//     marginRight: 36,
//   },
//
//   [`& .${classes.menuButtonHidden}`]: {
//     display: 'none',
//   },
//
//   [`& .${classes.title}`]: {
//     flexGrow: 1,
//   }
// }));

interface OnDrawerOpen {
  (): void;
}

interface Props {
  hideNotification?: boolean;
  open: boolean;
  actions?: MenuAction[];
  title: string;
  onDrawerOpen?: OnDrawerOpen;
}

export default function SmeAppBar(props: Props): JSX.Element {
  const { actions, title, open, onDrawerOpen, hideNotification } = props;
  return (
    <StyledAppBar position="fixed" open={open}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onDrawerOpen}
          className={classes.menuButton}
          size="large"
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
          {title}
        </Typography>
        <ProfileNav hideNotification={hideNotification} actions={actions} />
      </Toolbar>
    </StyledAppBar>
  );
}
